<template>
  <div id="SinglePotHome">
    <el-tabs v-model="activeTab">
      <!-- 详情 -->
      <el-tab-pane label="详情页面" name="info">
        <info1 ref="info1" :productId="productId" :infoData="infoData"></info1>
        <info2
          ref="info2"
          :productId="productId"
          :infoData="infoData"
          class="marginT20"
          :pages="pages"
          :propertes="propertes"
        ></info2>
        <div class="clearfloat">
          <el-button
            type="primary"
            class="saveBtn right"
            @click="handleSubmitInfo"
            >保存</el-button
          >
        </div>
      </el-tab-pane>
      <!-- 次级 -->
      <el-tab-pane label="次级页面" name="secondary">
        <secondaryHome
          v-if="activeTab == 'secondary'"
          :templateId="templateId"
          :productId="productId"
          :pages="pages"
          :propertes="propertes"
          @getPages="handleGetPages"
        ></secondaryHome>
      </el-tab-pane>
      <!-- 浮窗 -->
      <el-tab-pane label="浮窗" name="dialog">
        <Dialog
          v-if="activeTab == 'dialog'"
          :templateId="templateId"
          :productId="productId"
          :pages="pages"
          :propertes="propertes"
          @getPages="handleGetPages"
        />
      </el-tab-pane>
      <el-tab-pane label="滤芯管理" name="filter">
        <filter-manage
          ref="filter"
          v-if="activeTab == 'filter'"
          :templateId="templateId"
          :productId="productId"
          :pages="pages"
          :propertes="propertes"
          @getPages="handleGetPages"
        ></filter-manage>
        <div class="clearfloat">
          <el-button
            type="primary"
            class="saveBtn right"
            @click="handleSubmitFilter"
            >保存</el-button
          >
        </div>
      </el-tab-pane>
      <!-- 更多 -->
      <el-tab-pane label="更多" name="more">
        <more
          ref="more"
          :productId="productId"
          :moreData="moreData"
          :pages="pages"
          :propertes="propertes"
        ></more>
        <div class="clearfloat">
          <el-button
            type="primary"
            class="saveBtn right"
            @click="handleSubmitMore"
            >保存</el-button
          >
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import info1 from "./info1";
import info2 from "./info2";
import secondaryHome from "./secondaryHome";
import Dialog from "./DialogPage";
import Filter from "./filter";
import more from "./more";
export default {
  name: "SinglePotHome",
  props: {
    productId: {
      type: String,
      default: () => {
        return "";
      }
    },
    templateId: {
      default: () => {
        return "";
      }
    }
  },
  components: {
    info1,
    info2,
    secondaryHome,
    'filter-manage':Filter,
    Dialog,
    more
  },
  data() {
    return {
      pages: [],
      propertes: [],
      moreData: {},
      infoData: {}, // 详情页数据
      activeTab: "info"
    };
  },
  mounted() {
    this.handleGetPages();
    this.getPropertes();
    this.getMoreInfo();
    this.getInfoPage();
  },
  methods: {
    // 获取次级页面列表
    handleGetPages() {
      this.$http.productSecondaryPages(this.productId).then(res => {
        if (res.data.success) {
          this.pages = res.data.data;
        }
      });
    },
    // 获取所有属性列表
    getPropertes() {
      this.$http
        .productModelFuncListALL({ productId: this.productId })
        .then(res => {
          if (res.data.success) {
            this.propertes = res.data.data;
          }
        });
    },
    // 获取详情页面详情
    getInfoPage() {
      this.$http.appTempInfoPageDetail(this.productId).then(res => {
        if (res.data.success && res.data.data) {
          this.infoData = res.data.data;
        }
      });
    },
    // 准备提交详情页面
    handleSubmitInfo() {
      let info1 = this.$refs.info1.handleSubmit(),
        info2 = this.$refs.info2.handleSubmit();
      let form = {
          productId: this.productId,
          templateTypeId: this.templateId,
          ...info2
        },
        uplpadList = [],
        oldFileNames = "",
        formData = new FormData();
      // 若含有图片文件，存入表单
      if (info1.bgFile) {
        uplpadList.push("outerImageFilename");
        formData.append("files", info1.bgFile);
        // 若有旧文件，记录
        if (this.infoData.outerImageFilename) {
          oldFileNames = this.infoData.outerImageFilename + ",";
        }
      } else {
        form.outerImageFilename = this.infoData.outerImageFilename;
      }
      // 若含有图片文件，存入表单
      if (info1.productFile) {
        uplpadList.push("innerImageFilename");
        formData.append("files", info1.productFile);
        // 若有旧文件，记录
        if (this.infoData.innerImageFilename) {
          oldFileNames = oldFileNames + this.infoData.innerImageFilename;
        }
      } else {
        form.innerImageFilename = this.infoData.innerImageFilename;
      }
      if (uplpadList.length > 0) {
        formData.append("oldFileNames", oldFileNames);
        this.$http.uploadFiles(formData).then(res => {
          if (res.data.success) {
            for (let i in uplpadList) {
              form[uplpadList[i]] = res.data.data[i];
            }
            this.submitInfoForm(form);
          }
        });
      } else {
        this.submitInfoForm(form);
      }
    },
    // 提交详情页面表单
    submitInfoForm(form) {
      if (this.infoData.id) {
        form.id = this.infoData.id;
      }
      let ajax = this.infoData.id
        ? this.$http.appTempInfoPageEdit
        : this.$http.appTempInfoPageAdd;
      ajax(form).then(res => {
        if (res.data.success) {
          this.getInfoPage();
        }
      });
    },
    // ——————————————更多——————————————
    // 获取更多页面
    getMoreInfo() {
      this.$http
        .morePageInfo({
          productId: this.productId
        })
        .then(res => {
          if (res.data.success) {
            this.moreData = res.data.data;
          }
        });
    },
    handleSubmitFilter() {
      let params = this.$refs.filter.handleSubmit();
      if (params != false) {
        params.productId = this.productId;
        params.templateTypeId = this.templateId;
        params.inner = true;
        this.$http.secondPageEdit(params).then(res => {
          if (res.data.success) {
          }
        });
      }
    },
    // 准备提交详情页面
    handleSubmitMore() {
      let more = this.$refs.more.handleSubmit(),
        form = {
          productId: this.productId,
          airMore: more
        };
      if (this.moreData != null && this.moreData.id) {
        form.id = this.moreData.id;
      }
      let ajax =
        this.moreData != null && this.moreData.id
          ? this.$http.morePageEdit
          : this.$http.morePageAdd;
      ajax(form).then(res => {
        if (res.data.success) {
          this.getMoreInfo();
        }
      });
    }
  }
};
</script>

<style scoped>
.saveBtn {
  width: 100%;
  height: 50px;
  margin-top: 20px;
}
</style>
